<template>
  <div class="accruals-schedule-table fbc-table-header-labels" data-testid="accruals-schedule-table">
    <lb-datatableaction
      ref="dataTable"
      auto-height
      :headers="headers"
      :tabledata="rows"
      :displayed-row-count="rows.length"
      :itemsperpage="itemsPerPage"
      :filter-options-data="filterOptionsData"
      :bulk-actions="false"
      header-bg-class="fbc-table-header-bg"
      data-testid="accruals-schedule-table__datatable"
      @filter-item="$emit('filter-item', $event)"
      @clear-item="$emit('clear-filter')"
      @filter-active-change="$emit('filter-active-change', $event)"
    >
      <template #tbody>
        <template v-for="(item, index) in rows">
          <tr
            :key="item._id"
            class="accruals-schedule-table__row"
            :class="{ 'accruals-schedule-table__row--expanded': isExpanded(item._id) }"
            :data-testid="`accruals-schedule-table__row--${index}`"
            @click="onToggle(item)"
          >
            <td class="accruals-schedule-table__expand-cell">
              <button
                type="button"
                class="accruals-schedule-table__expand-btn"
                :aria-expanded="isExpanded(item._id) ? 'true' : 'false'"
                :aria-label="isExpanded(item._id) ? 'Collapse journals' : 'Expand journals'"
                :data-testid="`accruals-schedule-table__expand--${index}`"
                @click.stop="onToggle(item)"
              >
                <img
                  :src="assets.ESTIMATES_ROW_CHEVRON"
                  alt=""
                  class="accruals-schedule-table__expand-icon"
                  :class="{ 'accruals-schedule-table__expand-icon--open': isExpanded(item._id) }"
                />
              </button>
            </td>
            <td
              class="accruals-schedule-table__location"
              :data-testid="`accruals-schedule-table__cell-location--${index}`"
            >
              {{ item.location || '—' }}
            </td>
            <td
              class="accruals-schedule-table__vendor"
              :data-testid="`accruals-schedule-table__cell-vendor--${index}`"
            >
              {{ item.vendor || '—' }}
            </td>
            <td
              :data-testid="`accruals-schedule-table__cell-gl--${index}`"
            >
              <div class="accruals-schedule-table__gl">
                <span class="accruals-schedule-table__gl-code">{{ item.glCode || '—' }}</span>
                <span
                  v-if="item.glName && item.glName !== '—'"
                  class="accruals-schedule-table__gl-name"
                >{{ item.glName }}</span>
              </div>
            </td>
            <td
              class="accruals-schedule-table__amount-cell"
              :data-testid="`accruals-schedule-table__cell-amount--${index}`"
            >
              <span class="accruals-schedule-table__amount">{{ formatAmount(item.totalAmount) }}</span>
            </td>
          </tr>
          <tr
            v-if="isExpanded(item._id)"
            :key="`${item._id}-journals`"
            class="accruals-schedule-table__expand-row"
          >
            <td :colspan="headers.length">
              <div class="accruals-schedule-table__journals">
                <div
                  v-if="!(item.journals && item.journals.length)"
                  class="accruals-schedule-table__journal accruals-schedule-table__journal--empty"
                  :data-testid="`accruals-schedule-table__journal-empty--${index}`"
                >
                  No journal entries for this location
                </div>
                <div
                  v-for="(journal, jeIndex) in item.journals"
                  :key="`${item._id}-${journal.jeRef}`"
                  class="accruals-schedule-table__journal"
                  :data-testid="`accruals-schedule-table__journal--${index}-${jeIndex}`"
                >
                  <div class="accruals-schedule-table__journal-meta">
                    <span class="accruals-schedule-table__je-ref">{{ journal.jeRef }}</span>
                    <span class="accruals-schedule-table__je-desc">{{ journal.description }}</span>
                  </div>
                  <div class="accruals-schedule-table__journal-values">
                    <span class="accruals-schedule-table__je-amount">{{ formatAmount(journal.amount) }}</span>
                    <span
                      class="accruals-schedule-table__je-gl"
                      :data-testid="`accruals-schedule-table__je-from--${index}-${jeIndex}`"
                    >{{ journal.debitGl }}</span>
                    <span class="accruals-schedule-table__je-gl-arrow" aria-hidden="true">→</span>
                    <span
                      class="accruals-schedule-table__je-gl accruals-schedule-table__je-gl--credit"
                      :data-testid="`accruals-schedule-table__je-to--${index}-${jeIndex}`"
                    >{{ journal.creditGl }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </template>
    </lb-datatableaction>
  </div>
</template>

<script>
import { ACCRUALS_ASSETS } from '../accrualsPageConstants';
import {
  ACCRUALS_SCHEDULE_TABLE_HEADERS,
  formatEstimateMoney,
} from '../accrualsEstimatesConstants';

export default {
  name: 'AccrualsScheduleTable',
  props: {
    rows: { type: Array, default: () => [] },
    filterOptionsData: { type: Array, default: () => [] },
    expandedIds: { type: Array, default: () => [] },
    itemsPerPage: { type: Number, default: 25 },
  },
  data() {
    return {
      assets: ACCRUALS_ASSETS,
      headers: ACCRUALS_SCHEDULE_TABLE_HEADERS,
    };
  },
  methods: {
    formatAmount(value) {
      return formatEstimateMoney(value);
    },
    isExpanded(id) {
      return (this.expandedIds || []).includes(id);
    },
    onToggle(item) {
      console.log('[AccrualsScheduleTable]:', { action: 'toggle', rowId: item?._id });
      this.$emit('toggle-row', item);
    },
    clearColumnFilters() {
      this.$refs.dataTable?.clearFilter?.();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsScheduleTable.scss';
</style>
